import { useCallback } from 'react';
import qs from 'qs';
import { useHistory } from 'react-router-dom';

export const useFilterByStore = (totalProducts, filters, setAllProducts) => {
  const history = useHistory();

  const addUrlParam = (key, value) => {
    const parsedQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
    parsedQuery[key] = value;
    const updatedQuery = qs.stringify(parsedQuery, { encode: false });
    history.push(`${location.pathname}?${updatedQuery}`);
  };

  const filterByStore = useCallback(
    id => {
      const warehouseId = parseInt(id, 10);
      const activeItems = filters
        .filter(filter => filter.hasActiveItems)
        .flatMap(filter => filter.items.filter(item => item.isActive));

      // Filter attributes from active items
      const activeAttributes = activeItems.filter(item =>
        item.id.includes('Attribute')
      );

      // Filter products based on matching attributes and stock in the specified warehouse
      const filteredProducts = totalProducts.filter(product =>
        product.variants.values.some(value => {
          // Check if the variant matches any active attribute
          const matchesAttribute = activeAttributes.some(
            attribute => value.values.toString() === attribute.text
          );

          // Check if the variant has stock in the specified warehouse
          const hasStock = value.warehouseStock?.some(
            stock =>
              parseInt(stock.location.id, 10) === warehouseId &&
              stock.stockLevel > 0
          );

          return matchesAttribute && hasStock;
        })
      );

      setAllProducts(filteredProducts);

      // setTimeout(() => {
      //   addUrlParam('storeid', id);
      // }, 1000)

      return filteredProducts;
    },
    [totalProducts, filters, setAllProducts]
  );

  return filterByStore;
};
